import { getGapComplexInformation } from 'api/gapOffer';
import { GAP_MAP_ZOOM_LEVEL } from 'constants/map';
import { FunctionComponent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMarkerInfo, setModal } from 'redux/store/mapReducer';
import { RootState } from 'redux/store/rootReducer';
import { GapOfferMarker } from 'types/gapOffer';

export interface GapMarkerProps {
  map?: naver.maps.Map;
  markerInfo: GapOfferMarker;
  onClick: (bldNm: string) => void;
  selectedBldNm: string;
}

const GapMarker: FunctionComponent<GapMarkerProps> = (props) => {
  const { map, markerInfo, onClick, selectedBldNm } = props;
  if (!map) return null;
  const dispatch = useDispatch();
  const { modal } = useSelector((state: RootState) => state.mapStore);
  const { latitude, longitude } = markerInfo.center;
  const zoom = map.getZoom();

  const markerOptions = {
    size: new naver.maps.Size(40, 54),
    anchor: new naver.maps.Point(40, 54),
    origin: new naver.maps.Point(0, 0),
  };

  useEffect(() => {
    const marker: naver.maps.Marker = new naver.maps.Marker({
      map,
      position: new naver.maps.LatLng(latitude, longitude),
      icon: {
        content: getMarkerContent(),
      },
    });
    changeMarkerIcon(marker);
    if (markerInfo.bldNm === selectedBldNm && zoom >= 13 && modal) {
      marker.setAnimation(naver.maps.Animation.BOUNCE);
    }
    const clickEventLister = marker.addListener('click', () => {
      if (zoom >= 13) {
        getGapInfoModal(markerInfo.complexId);
        onClick(markerInfo.bldNm);
      } else if (zoom === GAP_MAP_ZOOM_LEVEL.dong) {
        zoomIn(14);
      } else {
        zoomIn(12);
      }
    });

    return () => {
      marker.removeListener(clickEventLister);
      marker.setMap(null);
    };
  }, [markerInfo, selectedBldNm, modal]);

  const changeMarkerIcon = (marker: naver.maps.Marker) => {
    marker.setIcon({
      content: getMarkerContent(),
      ...markerOptions,
    });
    marker.setMap(map);
  };

  const getMarkerContent = () => {
    const defaultIcon = [
      `<div style="position: absolute; top: 0; left: 0; display:flex; flex-direction: column; align-items: center; z-index:0;" >`,
      '<div style=" height: 40px; width:78px; background-color: #FF5368;  display:flex; align-items: center; justify-content: center; flex-direction: column; box-shadow: 0px 0px 8px rgba(0, 30, 81, 0.12); border-radius: 8px; border: 1px solid rgba(239, 21, 47, 0.8);">',
      `   <div style="font-size:12px;color:#FFFFFF; font-weight:bold;">갭 ${markerInfo.gapPrice}</div>`,
      `   <div style="font-size:8px;color:#FFFFFF; margin-top: 2px; ">매매 ${markerInfo.tradePrice} | ${markerInfo.size}</div>`,
      '</div>',
      '<div style="width:0px; height:0px; border-left: 12px solid transparent; border-right: 12px solid transparent; border-top: 12px solid rgba(239, 21, 47, 0.8); position: relative;"></div>',
      '<div style= "width: 0;height: 0; border-left: 12px solid transparent; border-right: 12px solid transparent; border-top: 12px solid #FF5368;; position: absolute; bottom: 2px; left: 28px;"></div>',
      '</div>',
    ].join('');

    const selectedIcon = [
      `<div style="position: absolute; top: 0; left: 0; display:flex; flex-direction: column; align-items: center; z-index: 1;" >`,
      '<div style="height: 40px; width:78px; background-color: #FF5368; display:flex; align-items: center; justify-content: center; flex-direction: column; box-shadow: 0px 0px 8px rgba(0, 30, 81, 0.12); border-radius: 8px; border: 1px solid rgba(239, 21, 47, 0.8);">',
      `   <div style="font-size:12px;color:#FFFFFF; font-weight:bold;">갭 ${markerInfo.gapPrice}</div>`,
      `   <div style="font-size:8px;color:#FFFFFF; margin-top: 2px;">매매 ${markerInfo.tradePrice} | ${markerInfo.size}</div>`,
      '</div>',
      '<div style="width:0px; height:0px; border-left: 12px solid transparent; border-right: 12px solid transparent; border-top: 12px solid rgba(239, 21, 47, 0.8); position: relative;"></div>',
      '<div style= "width: 0;height: 0; border-left: 12px solid transparent; border-right: 12px solid transparent; border-top: 12px solid #FF5368;; position: absolute; bottom: 2px; left: 28px;"></div>',
      '</div>',
    ].join('');

    const MARKER_SIZE = {
      M: 64,
      L: 72,
    };

    let markerSize = MARKER_SIZE.M;
    if (zoom <= GAP_MAP_ZOOM_LEVEL.sido) {
      markerSize = MARKER_SIZE.L;
    }

    const clusteredIcon = [
      `<div style="position: absolute; top: 0; left: 0; display:flex; flex-direction: column; align-items: center; justify-content:center; background-color:rgba(239, 21, 47, 0.7); width: ${markerSize}px; height: ${markerSize}px; border-radius:40px; border: 1px solid #EF152F;" >`,
      `<div style="font-size:10px; color: #FFFFFF;  text-align: center;">${markerInfo?.districtName}</div>`,
      `<div style="font-size:16px; color: #FFFFFF; margin-top: 2px;">${markerInfo.count}</div>`,
      '</div>',
    ].join('');

    if (markerInfo.bldNm === selectedBldNm && zoom >= 13 && modal) {
      return selectedIcon;
    }

    if (zoom >= 13) {
      return defaultIcon;
    }

    return clusteredIcon;
  };

  const getGapInfoModal = async (complexId: number) => {
    const { data, error } = await getGapComplexInformation(complexId);
    if (error) {
      return;
    }

    if (data) {
      dispatch(setMarkerInfo(data));
      dispatch(setModal(true));
    }
  };

  const zoomIn = (zoomLevel: number) => {
    map.morph(new naver.maps.LatLng(latitude, longitude), zoomLevel);
  };

  return null;
};

export default GapMarker;
